class ShopTheLook extends HHBaseElement {
  constructor() {
    super()

    this.addToCartToggles = [...this.querySelectorAll('.js-add-to-cart')]
    this.addToCart = this.addToCart.bind(this)
  }

  connectedCallback() {
    this._attachListeners()
  }

  _attachListeners() {
    this.addToCartToggles.forEach((toggle) =>
      toggle.addEventListener('click', this.addToCart)
    )
  }

  addToCart(e) {
    const target = e.target
    const variantId = target.dataset.variantId

    window.__CART__CONTROLLER__.add({
      payload: {
        id: variantId,
        quantity: 1,
      },
    })
  }
}

window.customElements.define('shop-the-look', ShopTheLook)
